import { useState } from 'react'

import { guardarCredenciales } from '../api/cliente'
import { desactivar, desbloquear } from '../lib/biometria'

/**
 * Pantalla de bloqueo.
 *
 * No se pide la cara sola al arrancar: Safari exige un gesto del usuario
 * para WebAuthn, asi que hace falta el boton.
 */
export default function Bloqueo({ alAbrir }: { alAbrir: () => void }) {
  const [pidiendo, setPidiendo] = useState(false)
  const [fallo, setFallo] = useState<string | null>(null)

  async function intentar() {
    setPidiendo(true)
    setFallo(null)
    try {
      if (await desbloquear()) alAbrir()
      else setFallo('No se reconocio tu cara')
    } catch {
      // Cancelar el dialogo tambien cae aqui, y no es un error que contar
      setFallo('No se pudo verificar. Vuelve a intentarlo.')
    } finally {
      setPidiendo(false)
    }
  }

  /*
   * Salida de emergencia. Si el Face ID deja de funcionar y no hubiera forma
   * de saltarselo, la app quedaria cerrada con las descargas dentro. Volver
   * a entrar necesita red, asi que se avisa.
   */
  function olvidar() {
    if (!confirm('Se borrara tu sesion y el Face ID. Para volver a entrar necesitaras conexion.')) {
      return
    }
    desactivar()
    guardarCredenciales(null)
    location.reload()
  }

  return (
    <div className="acceso">
      <img src="/icons/marca.png" alt="Yomou" className="marca-acceso" />
      <h1>Yomou</h1>

      <p className="subtitulo">Desbloquea para continuar</p>

      {fallo && <p className="error-texto">{fallo}</p>}

      <button
        className="boton"
        onClick={intentar}
        disabled={pidiendo}
        style={{ width: '100%', marginTop: 18 }}
      >
        {pidiendo ? 'Esperando…' : 'Desbloquear con Face ID'}
      </button>

      <button className="boton secundario" onClick={olvidar} style={{ marginTop: 12 }}>
        Olvidar esta sesion
      </button>
    </div>
  )
}
